import styled from 'styled-components';

// UDS Typography's bold variant routes through a font-family swap with no matching
// @font-face, so it silently never renders bold - force it with !important, which
// beats Typography's own inline style (same fix pattern as form/css.js's SectionHeaderTitle).
// Target div/span directly (not just h4) - react-native-web's Text sets its own
// font-weight on the innermost text node, which otherwise wins over inheriting the h4's.
const SectionHeading = styled.div`
  h4,
  h4 div,
  h4 span {
    font-weight: 700 !important;
  }
`;

export default SectionHeading;
